import { render, staticRenderFns } from "./EmptyRequest.vue?vue&type=template&id=e34bfc4c&"
import script from "./EmptyRequest.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmptyRequest.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e34bfc4c')) {
      api.createRecord('e34bfc4c', component.options)
    } else {
      api.reload('e34bfc4c', component.options)
    }
    module.hot.accept("./EmptyRequest.vue?vue&type=template&id=e34bfc4c&", function () {
      api.rerender('e34bfc4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/EmptyRequest.vue"
export default component.exports